/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import ArticlePage from './components/ArticlePage';
import ArticleHero from './components/ArticleHero';
import ArticleInfos from './components/ArticleInfos';
import ArticleSearchSource from './components/ArticleSearchSource';
import ArticlesPage from './components/ArticlesPage';
import ArticleList from './components/ArticleList';
import ArticleListItem from './components/ArticleListItem';
import ArticlePickerModal from './components/ArticlePickerModal';
import ArticleListContent from './components/ArticleListContent';
import Article from './models/Article';
import search from './search';
import ArticleListState from './states/ArticleListState';
import ArticleSliderItem from './components/ArticleSliderItem';
import ArticleBookshelfDropdownModal from './components/ArticleBookshelfDropdownModal';
import LiteraryWorkPage from './components/LiteraryWorkPage';
import LiteraryWorkPageOrderButton from './components/LiteraryWorkPageOrderButton';
import LiteraryWorkState from './states/LiteraryWorkState';
import ArticleNoteModal from './components/ArticleNoteModal';

export default {
	'orell-articles/components/ArticlePage': ArticlePage,
	'orell-articles/components/ArticleHero': ArticleHero,
	'orell-articles/components/ArticleInfos': ArticleInfos,
	'orell-articles/components/ArticleSearchSource': ArticleSearchSource,
	'orell-articles/components/ArticlesPage': ArticlesPage,
	'orell-articles/components/ArticleList': ArticleList,
	'orell-articles/components/ArticleListItem': ArticleListItem,
	'orell-articles/components/ArticlePickerModal': ArticlePickerModal,
	'orell-articles/components/ArticleListContent': ArticleListContent,
	'orell-articles/models/Article': Article,
	'orell-articles/search': search,
	'orell-articles/states/ArticleListState': ArticleListState,
	'orell-articles/states/LiteraryWorkState': LiteraryWorkState,
	'orell-articles/components/ArticleSliderItem': ArticleSliderItem,
	'orell-articles/components/ArticleNoteModal': ArticleNoteModal,
	'orell-articles/components/ArticleBookshelfDropdownModal': ArticleBookshelfDropdownModal,
	'orell-articles/components/LiteraryWorkPageOrderButton': LiteraryWorkPageOrderButton,
	'orell-articles/components/LiteraryWorkPage': LiteraryWorkPage,
};
